










import { Vue, Component } from 'vue-property-decorator';
import AlertasCamaras from '@/pantallas/Camaras/Alertas/AlertasCamaras.vue';

@Component({
  components: { AlertasCamaras },
})
export default class AlertasVigilantiPantalla extends Vue {}
